<template>
  <div class="ipo-selector">
    <ul class="ipo-selector-tabs">
      <li v-for="item in items" :key="item.id">
        <button
          class="ipo-selector-tab"
          :class="{ 'ipo-selector-tab--active': selectedIpo && item.id === selectedIpo.id }"
          @click="$store.dispatch('ipoOrder/selectIpo', item)"
        >
          {{ tabLabel(item) }}
          <span class="ipo-selector-code">/ {{ item.exchange_server_code || '-' }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'IpoSelector',
  computed: {
    ...mapGetters('ipoOrder', ['items', 'selectedIpo']),
  },
  methods: {
    // Bond rows (type 3) read their symbol off the related brand_bond, which
    // can be absent — fall back instead of throwing during render.
    tabLabel(item) {
      if (item.type != 3) return item.symbol || '-'
      return (item.brand_bond && item.brand_bond.symbol) || '-'
    },
  },
}
</script>
